import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import {
  fetchScanPerformance,
  PerformanceScan,
} from '../fetch/fetchScanPerformance';

export function useGetPerformanceScanList(
  startDate: Dayjs,
  endDate: Dayjs
): {
  performanceScanList: PerformanceScan[];
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [performanceScanList, setPerformanceScanList] =
    useState<PerformanceScan[]>(null);

  const startString = dayjs(startDate).format('YYYY-MM-DD');
  const endString = dayjs(endDate).format('YYYY-MM-DD');

  useEffect(() => {
    const fetchPerformanceScanListMethod = async () => {
      const performanceScanListResult = await fetchScanPerformance(
        startString,
        endString
      );

      setPerformanceScanList(performanceScanListResult);
      setIsLoading(false);
    };

    fetchPerformanceScanListMethod();
  }, [endString, setIsLoading, startString]);

  return { performanceScanList, isLoading };
}
